// This class will hold instances of file information picked by the
// input control.
// Since these are not possible to be held in Redux, we keep them here,
// and in Redux we keep just a temporary ID to retrieve this information
// when necessary.

export class PickedFilesHandler {

  constructor() {
    this.mapFiles = new Map<number, File>();
    this.autoKey = 0;
  }

  addFile = (file: File) => {
    this.autoKey++;
    this.mapFiles.set(this.autoKey, file);

    return this.autoKey;
  };

  getFile = (key: number) => {
    return this.mapFiles.get(key);
  };

  private mapFiles: Map<number, File>;
  private autoKey: number;
}
